import { get, post } from './axios'

export default {
  // 获取签署页面
  getContractSignInfo(params, config) {
    return post('/ecs/contractInfo/getContractSignInfo.jspa', params, config)
  },
  // 实名认证
  livenessVerifyDirect(params, config) {
    return post('/ecs/face/livenessVerifyDirects.jspa', params, config)
  },
  // 人脸视频实名认证
  livenessVerifyUrl(params, config) {
    return post('/ecs/face/livenessVerifyUrl.jspa', params, config)
  },
  // 印章列表
  getsignListFlowId(params, config) {
    return post('/ecs/signInfo/getsignListFlowId.jspa', params, config)
  },
  // 签署接口
  contractSign(params, config) {
    return post('/ecs/contractInfo/contractSign.jspa', params, config)
  },
  // 添加签名
  addSignFlowId(params, config) {
    return post('/ecs/signInfo/addSignFlowId.jspa', params, config)
  },
  // 获取短信验证码
  sendMobileSms(params, config) {
    return post('/ecs/contractInfo/sendMobileSms.jspa', params, config)
  },
  // 短信验证码签署
  h5BatchSmsContractSign(params, config) {
    return post('/ecs/contractInfo/h5BatchSmsContractSign.jspa', params, config)
  },
  // 短信验证码签署
  handWritingAddSign(params, config) {
    return post('/ecs/signApiPage/handWritingAddSign.jspa', params, config)
  },

  // 校验人脸taskId是否有效
  getLivenessVerifyTaskStatus(params, config) {
    return post('/ecs/face/getLivenessVerifyTaskStatus.jspa', params, config)
  },
}
